import React, { useEffect, useState } from 'react';
import { apiDelete, apiGet, apiPost, apiPut } from '../../../API/Api_Url';
import { X, MapPin, Calendar, DollarSign, FileCheck, CheckCircle, XCircle, DeleteIcon } from 'lucide-react';
import { FaCheckCircle, FaEdit, FaEye, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import FreelancerPaymentModeModal1 from '../../Modal/FreelancerPaymentModeModal1';
import DeleteMilestoneModal from '../../Modal/DeleteMilestoneModal';
import JobCompleteModal from '../../Modal/JobCompleteModal';

function ContractorAllFreelancerJobPost({ RequirementState, setRequirementState }) {
    const navigate = useNavigate();
    const [FreelancerJobPost, setFreelancerJobPost] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetContractorAllFreelancerJobPost = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet('api/contractor/ContractorGetAllFreelancerJobPost');
            setFreelancerJobPost(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        GetContractorAllFreelancerJobPost();
    }, []);

    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'Approved':
            case 'Accepted':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const [expandedJob, setExpandedJob] = useState(null);

    const toggleBids = async (reqId) => {
        if (expandedJob === reqId) {
            setExpandedJob(null);
            setAllbids([]);
        } else {
            await GetAllbidofJobPost(reqId);
            setExpandedJob(reqId);
        }
    };

    const [Allbids, setAllbids] = useState([]);
    const [IsbidLoading, setIsbidLoading] = useState(false);

    const GetAllbidofJobPost = async (id) => {
        try {
            setIsbidLoading(true)
            const response = await apiGet(`api/contractor/ContractorGetAllbidofJobPost/${id}`);
            setAllbids(response?.data);
            setIsbidLoading(false)
        } catch (error) {
            setIsbidLoading(false)
            console.error('Error fetching data:', error);
        } finally {
            setIsbidLoading(false)
        }
    };


    const ContractorFinalizeFreelancerJobBid = async (jobPostId, bidId) => {
        try {
            const data = {
                jobPostId,
                bidId
            }
            setIsUploading(true);
            const response = await apiPost('api/contractor/ContractorFinalizeFreelancerJobBid', data);
            toast.success(response?.message || 'Bid Finlize completed')
            GetContractorAllFreelancerJobPost()
            setExpandedJob(null);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };

    const UserUpdateAgreementofJobPost = async (jobPostId) => {
        try {
            setIsUploading(true);
            const data = {
                action: "Accepted"
            }
            const response = await apiPut(`api/contractor/ContractorUpdateAgreementofJobPost/${jobPostId}`, data);
            toast.success(response?.message || 'Bid Finlize completed')
            GetContractorAllFreelancerJobPost()
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };

    const [PaymentModeModal, setPaymentModeModal] = useState(false);
    const [SelectedRequirement, setSelectedRequirement] = useState(null);

    const OpenPaymentModel = (data) => {
        setPaymentModeModal(true)
        setSelectedRequirement(data)
    }
    const ClosePaymentModel = () => {
        setPaymentModeModal(false)
        setSelectedRequirement(null)
    }

    const [DeleteMilestone, setDeleteMilestone] = useState(false);
    const [reqId, setreqId] = useState(null);
    const [milestoneid, setmilestoneid] = useState(null);

    const OpenDeleteMilestone = (requirementId, milestoneId) => {
        setreqId(requirementId)
        setmilestoneid(milestoneId)
        setDeleteMilestone(true)
    }
    const CloseDeleteMilestone = () => {
        setreqId(null)
        setmilestoneid(null)
        setDeleteMilestone(false)
    }

    const handleDeleteMilestone = async () => {
        try {
            const response = await apiDelete(`api/contractor/contractorDeleteMilestone/${reqId}/${milestoneid}`);
            toast.success(response?.message || "Milestone deleted successfully");
            CloseDeleteMilestone()
            GetContractorAllFreelancerJobPost();
        } catch (error) {
            console.error("Error deleting milestone:", error);
            toast.error("Failed to delete milestone");
        }
    };


    const [Completedjob, setCompletedjob] = useState(false);


    const OpenCompletedjobModel = (requirementId) => {
        setreqId(requirementId)
        setCompletedjob(true)
    }
    const CloseCompletedjob = () => {
        setreqId(null)
        setCompletedjob(false)
    }


    const handleUserCompleteJobPost = async () => {
        try {
            const response = await apiPut(
                `api/contractor/ContractorCompleteJobPost/${reqId}`
            );
            toast.success(response?.message || "Job Complete And Moved to completed Section ");
            setCompletedjob()
            GetContractorAllFreelancerJobPost();
        } catch (error) {
            console.error("Error deleting milestone:", error);
            toast.error("Failed to delete milestone");
        }
    };




    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            My All Freelancer Job Posts
                        </h1>
                        <p className="text-gray-600">Manage and track your freelancer job posts</p>
                    </div>
                    <div className="flex items-center gap-4 mt-4 md:mt-0">
                        <button
                            onClick={() => navigate('/ContractorAddFreelancerJobPost')}
                            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 text-white bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90"
                        >
                            <FaPlus className="h-4 w-4" />
                            Add Job Post
                        </button>
                        <select
                            value={RequirementState}
                            onChange={(e) => setRequirementState(e.target.value)}
                            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0060B9]"
                        >
                            <option value="All">All</option>
                            <option value="pending">Pending</option>
                            <option value="Selected">Selected</option>
                            <option value="AgreementPending">Agreement Pending</option>
                            <option value="InConstruction">In Construction</option>
                            <option value="Completed">Completed</option>
                        </select>
                    </div>

                </div>

                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading your projects...</p>
                    </div>
                ) : FreelancerJobPost?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">No Freelancer Job Posts found.</p>
                        <p className="text-gray-400 mt-2">Create your first job post to get started.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {FreelancerJobPost?.map((req) => (
                            <div key={req?._id} className="bg-white rounded-2xl shadow-lg p-6">
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-xl font-bold text-gray-900">{req?.Title}</h3>
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(req?.Status)}`}
                                    >
                                        {req?.Status}
                                    </span>
                                </div>
                                {req?.IsAdminApprove ? (
                                    <div className="flex items-center gap-2 text-green-600 mb-4">
                                        <CheckCircle className="h-5 w-5" />
                                        <p className="text-sm font-medium">Approved by Admin</p>
                                    </div>
                                ) : (
                                    <div className="flex items-center gap-2 text-red-500 mb-4">
                                        <XCircle className="h-5 w-5" />
                                        <p className="text-sm font-medium">Not Approved by Admin</p>
                                    </div>
                                )}

                                <p className="text-gray-700 mb-3">{req?.Description}</p>

                                {req?.Skillsrequire?.length > 0 && (
                                    <p className="text-sm text-gray-600 mb-3">
                                        <span className="font-medium">Skills Required:</span> {req?.Skillsrequire.join(', ')}
                                    </p>
                                )}

                                <div className="grid grid-cols-2 gap-4 text-sm mb-4">
                                    <div className="flex items-center text-gray-700">
                                        <DollarSign className="h-4 w-4 mr-2 text-purple-500" />
                                        <p><span className="font-medium">Budget:</span> ₹{req?.Budget}</p>
                                    </div>

                                    <div className="flex items-center text-gray-700">
                                        <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                        <p><span className="font-medium">Timeline:</span> {formatDate(req?.timeline?.startDate)} - {formatDate(req?.timeline?.endDate)}</p>
                                    </div>
                                </div>

                                {req?.location && (
                                    <div className="flex items-start text-gray-600 mb-4">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">{req?.location?.Address}, {req?.location?.City}, {req?.location?.State}</p>
                                    </div>
                                )}
                                {req?.SelectedFreelanceEngineer && (
                                    <div className="bg-blue-50 p-4 rounded-lg border text-sm text-gray-700">
                                        <h4 className="font-semibold mb-2">Selected Freelance Engineer</h4>
                                        <p>Bid ID: {req?.SelectedFreelanceEngineer?.SelectedBid}</p>
                                        <p>Engineer ID: {req?.SelectedFreelanceEngineer?.FreelanceEngineer}</p>
                                        <p>Price: ₹{req?.SelectedFreelanceEngineer?.Price}</p>
                                    </div>
                                )}

                                <div className="mt-4 bg-gray-50 p-4 rounded-lg border text-sm text-gray-700 space-y-3">
                                    <div className="flex items-center justify-between">
                                        <p>
                                            <span className="font-medium">Freelance Agreement:</span>{" "}
                                            {req?.FreelanceEngineerAgreementRequest || "Not Requested"}
                                        </p>
                                    </div>

                                    <div className="flex items-center justify-between">
                                        <p>
                                            <span className="font-medium">User Agreement:</span>{" "}
                                            {req?.UserAgreementRequest || "Not Requested"}
                                        </p>
                                        {req?.UserAgreementRequest === "Pending" && (
                                            <button
                                                onClick={() => UserUpdateAgreementofJobPost(req?._id)}
                                                className="px-3 py-1 bg-green-500 text-white text-xs rounded-lg hover:bg-green-600 transition"
                                            >
                                                ✅ Approve Agreement
                                            </button>
                                        )}
                                    </div>
                                </div>
                                {req?.PaymentFlow && (
                                    <div className="bg-green-50 p-4 rounded-lg border text-sm text-gray-700 mt-3">
                                        <h4 className="font-semibold mb-2">Payment Flow</h4>
                                        <p><span className="font-medium">Mode:</span> {req?.PaymentFlow?.Mode}</p>
                                        {req?.PaymentFlow?.Mode === "Milestone" && (
                                            <div className="mt-3 space-y-2">
                                                <h5 className="font-medium">Milestones:</h5>
                                                {req?.PaymentFlow?.Milestones?.map((m) => (
                                                    <div
                                                        key={m?._id}
                                                        className="border rounded-lg p-3 bg-white shadow-sm relative">
                                                        <div className="flex justify-between items-start">
                                                            <div>
                                                                <p className="font-medium">{m?.Title}</p>
                                                                <p className="text-sm text-gray-600">{m?.Description}</p>
                                                                <p>Amount: ₹{m?.Amount}</p>
                                                                <p>Status: {m?.Status}</p>
                                                                <p>Due: {formatDate(m?.DueDate)}</p>
                                                            </div>
                                                            <button
                                                                onClick={() => OpenDeleteMilestone(req?._id, m?._id)}
                                                                className="text-red-500 hover:text-red-700 text-sm ml-4"
                                                            >
                                                                <DeleteIcon />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                    </div>
                                )}
                                {req?.WorkTracker?.length > 0 && (
                                    <div className="bg-gray-50 p-4 rounded-xl border mb-4">
                                        <h4 className="font-semibold text-gray-800 mb-2">Work Tracker</h4>
                                        {req?.WorkTracker.map((tracker) => (
                                            <div key={tracker?._id} className="mb-3 p-2 border rounded-md bg-white">
                                                <p className="text-sm font-medium mb-1">Title: {tracker?.Title}</p>
                                                <p className="text-sm text-gray-700 mb-1">Description: {tracker?.Description}</p>
                                                <p className="text-sm text-gray-700 mb-1">Date: {tracker?.Date}</p>
                                                <p className="text-sm text-gray-700 mb-1">
                                                    Status:{" "}
                                                    <span
                                                        className={`px-2 py-0.5 rounded-md text-xs font-medium ${tracker?.Status === "Pending"
                                                            ? "bg-yellow-100 text-yellow-700"
                                                            : "bg-green-100 text-green-700"
                                                            }`}
                                                    >
                                                        {tracker?.Status}
                                                    </span>
                                                </p>
                                                {tracker?.Media?.FileUrl && (
                                                    <a
                                                        href={tracker?.Media?.FileUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="inline-block mt-2 px-3 py-1 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
                                                    >
                                                        {tracker?.Media?.FileType === "image" ? "View Image" : "View Video"}
                                                    </a>
                                                )}
                                            </div>
                                        ))}

                                    </div>
                                )}

                                <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                                    <span className="flex items-center">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        Created: {formatDate(req?.createdAt)}
                                    </span>
                                    <div className="flex gap-2">
                                        <button
                                            // onClick={() => navigate(`/FreelancerJobPostDetail/${req?._id}`)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                                        >
                                            <FaEye className="h-4 w-4" /> View Details
                                        </button>
                                        <button
                                            onClick={() => OpenPaymentModel(req)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                                        >
                                            <FaEdit className="h-4 w-4" />
                                            Add Payment Transaction
                                        </button>
                                        {req?.Status === 'InConstruction' &&
                                            <button
                                                onClick={() => OpenCompletedjobModel(req?._id)}
                                                className="flex items-center gap-1 px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                                            >
                                                <FaEdit className="h-4 w-4" />
                                                Make Job Status Completed.
                                            </button>
                                        }
                                        {req?.Status == 'Pending' &&
                                            <button
                                                onClick={() => toggleBids(req?._id)}
                                                className="mt-3 text-sm text-blue-600 hover:underline flex items-center gap-2"
                                                disabled={IsbidLoading}
                                            >
                                                {IsbidLoading && expandedJob === req?._id ? (
                                                    <>
                                                        <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                                        <span>Loading...</span>
                                                    </>
                                                ) : expandedJob === req?._id ? (
                                                    "Hide Bids"
                                                ) : (
                                                    "Show Bids"
                                                )}
                                            </button>
                                        }
                                    </div>
                                </div>
                                {expandedJob === req?._id && (
                                    <div className="mt-4 border-t pt-4 space-y-4">
                                        {isUploading ? (
                                            <p className="text-gray-500 text-center">Loading bids...</p>
                                        ) : Allbids?.length === 0 ? (
                                            <p className="text-gray-500 text-center">No bids found for this job post.</p>
                                        ) : (
                                            Allbids?.map((bid) => (
                                                <div
                                                    key={bid?._id}
                                                    className="bg-gradient-to-r from-white to-gray-50 border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition p-5"
                                                >
                                                    <div className="flex justify-between items-center mb-3">
                                                        <h4 className="text-base font-semibold text-gray-900">
                                                            💬 Proposal
                                                        </h4>
                                                        <span
                                                            className={`px-3 py-1 text-xs font-medium rounded-full ${bid?.Status === "Pending"
                                                                ? "bg-yellow-100 text-yellow-800"
                                                                : bid?.Status === "Accepted"
                                                                    ? "bg-green-100 text-green-800"
                                                                    : "bg-red-100 text-red-800"
                                                                }`}
                                                        >
                                                            {bid?.Status}
                                                        </span>
                                                    </div>

                                                    <p className="text-gray-700 text-sm mb-4 leading-relaxed">
                                                        {bid?.Note}
                                                    </p>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-gray-600 mb-4">
                                                        <div className="flex items-center">
                                                            <span className="mr-2">💰</span>
                                                            <span>
                                                                <span className="font-medium">Proposed Price:</span> ₹{bid?.ProposedPrice}
                                                            </span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <span className="mr-2">📅</span>
                                                            <span>
                                                                <span className="font-medium">Timeline:</span>{" "}
                                                                {new Date(bid?.Timeline?.startDate).toLocaleDateString()} -{" "}
                                                                {new Date(bid?.Timeline?.endDate).toLocaleDateString()}
                                                            </span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <span className="mr-2">🕒</span>
                                                            <span>
                                                                <span className="font-medium">Created:</span>{" "}
                                                                {new Date(bid?.createdAt).toLocaleDateString()}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="flex justify-end">
                                                        <button
                                                            onClick={() => ContractorFinalizeFreelancerJobBid(req?._id, bid?._id)}
                                                            className="px-4 py-2 text-sm bg-green-500 text-white rounded-lg shadow hover:bg-green-600 focus:ring-2 focus:ring-green-300 transition"
                                                        >
                                                            ✅ Select This Bid
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>

                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <FreelancerPaymentModeModal1
                isOpen={PaymentModeModal}
                onClose={ClosePaymentModel}
                SelectedRequirement={SelectedRequirement}
                GetContractorAllFreelancerInConstructionJobPost={GetContractorAllFreelancerJobPost}
                onSubmit={ClosePaymentModel}
            />
            <DeleteMilestoneModal
                isOpen={DeleteMilestone}
                onClose={CloseDeleteMilestone}
                onConfirm={handleDeleteMilestone}
            />

            <JobCompleteModal
                isOpen={Completedjob}
                onClose={CloseCompletedjob}
                onConfirm={handleUserCompleteJobPost}
            />

        </div>
    );
}

export default ContractorAllFreelancerJobPost;
